<template src="./index.html">
</template>
<script>
import data from './data.js'
export default {
  name: '',
  components: {
  },
  props:{
	  toseediag:{
		  type:Boolean,
		  default:false
	  },
	  headData:{
		  type:Array,
		  default:[]
	  },
	  tableData:{
		  type:Array,
		  default:[]
	  },
	  pagination:{
		  type:Object,
		  default:{}
	  }
  },
  data: function() {
    return {
		
    };
  },
  created() {
  },
  methods: {
	  closediag(e){
	  		  this.$emit("closediag",e)
	  },
	  sizechange(e){
		    this.$emit("sizechange",e)
	  },
	  currentChange(){
		    this.$emit("currentChange",false)
	  },
	  fordownload(e){
		    this.$emit("fordownload",e)
	  },
	  plxz(){
		  const arr= this.$refs.tableref.getSelectionval()
		  this.$emit("fordownloadpl",arr)
	  },
	  fodelete(e){
		    this.$emit("fodelete",e)
	  }
  }
};
</script>


<style scoped lang="less">
	@import url("./index.less");
</style>
